import { isRecordUnknown } from '@/utils/typeGuards'

export const isHtmlElement = (value: unknown): value is HTMLElement => {
  return value instanceof HTMLElement || (isRecordUnknown(value) && value.nodeType === Node.ELEMENT_NODE)
}

export function getStyleSheets(doc: Document = document): CSSStyleSheet[] {
  const sheets: CSSStyleSheet[] = []

  if (doc.styleSheets.length > 0) {
    return Array.from(doc.styleSheets)
  }

  const styleTags = doc.querySelectorAll('style')

  for (const styleTag of Array.from(styleTags)) {
    const cssText = styleTag.textContent || ''

    try {
      const sheet = new CSSStyleSheet()
      sheet.replaceSync(cssText)
      sheets.push(sheet)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Failed to parse styles:', e)
    }
  }

  return sheets
}

export function getAppliedClassStyles(doc: Document, element: HTMLElement): Record<string, string> {
  const styles: Record<string, string> = {}
  const sheets = getStyleSheets(doc)

  for (const sheet of sheets) {
    try {
      const rules = sheet.cssRules || sheet.rules

      for (const rule of Array.from(rules)) {
        if (rule instanceof CSSStyleRule) {
          try {
            if (element.matches(rule.selectorText)) {
              for (let i = 0; i < rule.style.length; i++) {
                const prop = rule.style[i]
                styles[prop] = rule.style.getPropertyValue(prop)
              }
            }
          } catch {
            // invalid selector, can safely swallow an error
          }
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Cannot access stylesheet:', sheet.href, e)
    }
  }

  return styles
}
